// Command prefixes for autonomous modes
const RALPH_COMMAND = "/ona:ralph";
const SPEC_COMMAND = "/ona:spec";

export type AgentModePrefix = "ralph" | "spec" | "agent";

/**
 * Parses agent mode command prefix from content.
 * Returns both the detected mode and the content with prefix stripped.
 */
export function parseAgentModePrefix(content: string): { mode: AgentModePrefix; strippedContent: string } {
    // Check Ralph prefix
    if (content.startsWith(RALPH_COMMAND)) {
        const remainder = content.slice(RALPH_COMMAND.length);
        if (remainder === "" || remainder.startsWith(" ")) {
            return { mode: "ralph", strippedContent: remainder.trimStart() };
        }
    }
    // Check Spec prefix
    if (content.startsWith(SPEC_COMMAND)) {
        const remainder = content.slice(SPEC_COMMAND.length);
        if (remainder === "" || remainder.startsWith(" ")) {
            return { mode: "spec", strippedContent: remainder.trimStart() };
        }
    }
    return { mode: "agent", strippedContent: content };
}
